import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import { Button } from "semantic-ui-react";
import { Row, Col, Grid } from "react-bootstrap";

import { animateScroll as scroll } from 'react-scroll';

import Header from "../../Header/Header";
import Sidebar from "../../Sidebar/Sidebar";
import BannerRectangleLarge from "../../Banner/BannerRectangleLarge";

import OSShipCard from "../../OSShipCard/OSShipCard";
import OSShipCardTable from "../../OSShipCard/OSShipCardTable";
import moment from "moment";
import "./ShipContent.css";

import { translate, getLanguage } from "../../Translation/Translation";
import { FETCH_URL } from "../../../utilities";

import { Polyline, Marker, InfoWindow } from "react-google-maps";
import ReactGA from "react-ga";

const {
  compose,
  withProps,
  lifecycle,
  withStateHandlers
} = require("recompose");
const {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  DirectionsRenderer
} = require("react-google-maps");

const MapWithADirectionsRenderer = compose(
  withScriptjs,
  withGoogleMap,
  withStateHandlers(
    () => ({
      isOpen: false
    }),
    {
      onToggleOpen: ({ isOpen }) => () => ({
        isOpen: !isOpen
      })
    }
  ),
  lifecycle({
    componentDidMount() {
      const google = window.google;
      let WAYPOINTS_ACTIVE = [];
      let WAYPOINTS_INACTIVE = [];
      let WAYPOINTS = [];
      let bounds = new google.maps.LatLngBounds();

      let AFTER_FINAL_STOP = false;
      for (var i = 0; i < this.props.trip.length; i++) {
        let latlng = {
          lat: parseFloat(this.props.trip[i].stop.latitude),
          lng: parseFloat(this.props.trip[i].stop.longitude)
        };

        if (AFTER_FINAL_STOP) {
          WAYPOINTS_INACTIVE.push(latlng);
        } else {
          WAYPOINTS_ACTIVE.push(latlng);
        }

        if (this.props.trip[i].stop.name == this.props.finalStop) {
          AFTER_FINAL_STOP = true;
        }
        WAYPOINTS.push(latlng);
      }

      for (var i = 0; i < WAYPOINTS.length; i++) {
        bounds.extend(WAYPOINTS[i]);
      }

      let MARKERS_MIDDLE = [];

      MARKERS_MIDDLE.push(
        <Marker
          key={WAYPOINTS_ACTIVE[0].lat}
          position={{
            lat: WAYPOINTS_ACTIVE[0].lat,
            lng: WAYPOINTS_ACTIVE[0].lng
          }}
          icon="http://portal.forthcrs.com/map/assets/icons/POI_marker_start.png"
        />
      );

      for (var i = 1; i < WAYPOINTS_ACTIVE.length - 1; i++) {
        MARKERS_MIDDLE.push(
          <Marker
            key={WAYPOINTS_ACTIVE[i].lat}
            position={{
              lat: WAYPOINTS_ACTIVE[i].lat,
              lng: WAYPOINTS_ACTIVE[i].lng
            }}
            icon="http://portal.forthcrs.com/map/assets/icons/POI_marker_big.png"
          />
        );
      }

      MARKERS_MIDDLE.push(
        <Marker
          key={WAYPOINTS_ACTIVE[WAYPOINTS_ACTIVE.length - 1].lat}
          position={{
            lat: WAYPOINTS_ACTIVE[WAYPOINTS_ACTIVE.length - 1].lat,
            lng: WAYPOINTS_ACTIVE[WAYPOINTS_ACTIVE.length - 1].lng
          }}
          icon="http://portal.forthcrs.com/map/assets/icons/POI_marker_end.png"
        />
      );

      const MARKERS_INACTIVE = WAYPOINTS_INACTIVE.map(stop => {
        return (
          <Marker
            key={stop.lat}
            position={{ lat: stop.lat, lng: stop.lng }}
            icon="http://portal.forthcrs.com/map/assets/icons/POI_marker_grayscale.png"
          />
        );
      });

      const MARKERS = MARKERS_MIDDLE.concat(MARKERS_INACTIVE);

      var WORLD_DIM = { height: 256, width: 256 };
      var ZOOM_MAX = 21;

      var mapDim = { width: 630, height: 300 };

      var ne = bounds.getNorthEast();
      var sw = bounds.getSouthWest();

      var sin = Math.sin(ne.lat() * Math.PI / 180);
      var radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
      var latRad1 = Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;

      var sin = Math.sin(sw.lat() * Math.PI / 180);
      var radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
      var latRad2 = Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;

      var latFraction = (latRad1 - latRad2) / Math.PI;

      var lngDiff = ne.lng() - sw.lng();
      var lngFraction = (lngDiff < 0 ? lngDiff + 360 : lngDiff) / 360;

      var latZoom = Math.floor(
        Math.log(mapDim.height / WORLD_DIM.height / latFraction) / Math.LN2
      );
      var lngZoom = Math.floor(
        Math.log(mapDim.width / WORLD_DIM.width / lngFraction) / Math.LN2
      );
      var zoom = Math.min(latZoom, lngZoom, ZOOM_MAX);

      if (WAYPOINTS.length == 2) {
        var zoom = zoom - 1;
      }

      let DIRECTIONS_INACTIVE = WAYPOINTS_INACTIVE;
      DIRECTIONS_INACTIVE.unshift(
        WAYPOINTS_ACTIVE[WAYPOINTS_ACTIVE.length - 1]
      );

      this.setState({
        directionsActive: WAYPOINTS_ACTIVE,
        directionsInActive: DIRECTIONS_INACTIVE,
        center: bounds.getCenter(),
        zoom: zoom,
        markers: MARKERS
      });
    }
  })
)(props => (
  <GoogleMap
    defaultZoom={6}
    zoom={props.zoom}
    center={props.center}
    defaultOptions={{
      styles: [
        {
          featureType: "all",
          elementType: "labels.text.fill",
          stylers: [{ saturation: 36 }, { color: "#333333" }, { lightness: 40 }]
        },
        {
          featureType: "all",
          elementType: "labels.text.stroke",
          stylers: [
            { visibility: "on" },
            { color: "#ffffff" },
            { lightness: 16 }
          ]
        },
        {
          featureType: "all",
          elementType: "labels.icon",
          stylers: [{ visibility: "off" }]
        },
        {
          featureType: "administrative",
          elementType: "geometry.fill",
          stylers: [{ color: "#fefefe" }, { lightness: 20 }]
        },
        {
          featureType: "administrative",
          elementType: "geometry.stroke",
          stylers: [{ color: "#fefefe" }, { lightness: 17 }, { weight: 1.2 }]
        },
        {
          featureType: "landscape",
          elementType: "geometry",
          stylers: [{ color: "#f6f6f6" }, { lightness: "-11" }]
        },
        {
          featureType: "poi",
          elementType: "geometry",
          stylers: [{ color: "#f5f5f5" }, { lightness: 21 }]
        },
        {
          featureType: "poi.park",
          elementType: "geometry",
          stylers: [{ color: "#dedede" }, { lightness: 21 }]
        },
        {
          featureType: "road.highway",
          elementType: "geometry.fill",
          stylers: [{ color: "#ffffff" }, { lightness: 17 }]
        },
        {
          featureType: "road.highway",
          elementType: "geometry.stroke",
          stylers: [{ color: "#ffffff" }, { lightness: 29 }, { weight: 0.2 }]
        },
        {
          featureType: "road.arterial",
          elementType: "geometry",
          stylers: [{ color: "#ffffff" }, { lightness: "-10" }]
        },
        {
          featureType: "road.local",
          elementType: "geometry",
          stylers: [{ color: "#ffffff" }, { lightness: "-12" }]
        },
        {
          featureType: "transit",
          elementType: "all",
          stylers: [{ visibility: "off" }]
        },
        {
          featureType: "transit",
          elementType: "geometry",
          stylers: [{ color: "#693b1d" }, { lightness: 19 }]
        },
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [
            { color: "#e9e9e9" },
            { lightness: "-47" },
            { saturation: "0" }
          ]
        }
      ]
    }}
  >
    {props.directionsActive && (
      <Polyline
        options={{
          geodesic: true,
          strokeColor: "rgb(41,63,84)",
          strokeOpacity: 1.0,
          strokeWeight: 3
        }}
        path={props.directionsActive}
      />
    )}
    {props.directionsInActive && (
      <Polyline
        options={{
          geodesic: true,
          strokeColor: "#edeeee",
          strokeOpacity: 1.0,
          strokeWeight: 3
        }}
        path={props.directionsInActive}
      />
    )}
    {props.markers}
  </GoogleMap>
));

class ShipsContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      outgoingAgencyBookingURL: null,
      incomingAgencyBookingURL: null,
      redirectBack: null,
      redirect: null,
      incomingTrip: null,
      outgoingTrip: null,
      incomingShipData: null,
      outgoingShipData: null,
      arrivalLocation: null,
      departureLocation: null
    };
  }

  goToBookingURL = url => {
    ReactGA.event({
      category: "Companies",
      action: "bookOnline",
      label: `${moment(this.props.data.match.params.sdate).format(
        "YYYYMMDD"
      )}#${moment(this.state.outgoingTrip.departureDateTime).format("HHmm")}#${
        this.state.outgoingTrip.company.id
      }#${this.state.outgoingShipData.vessel.id}#${
        this.state.departureLocation.id
      }#${this.state.arrivalLocation.id}#${moment(
        this.props.data.match.params.sdate
      ).format("YYYYMMDD")}#${moment(this.props.data.match.params.edate).format(
        "YYYYMMDD"
      )}#2b735297-625f-412f-8bd0-6a6498d494e0#2104675081`
    });

    var form = document.createElement("form");

    let bookingURL = url;
    if (url.toLowerCase().indexOf("npgres.exe") > -1) {
      if (url.indexOf("PM=BO") != -1) {
        bookingURL = `${bookingURL}`;
      } else if (url.indexOf("PM=BM") != -1) {
        bookingURL = `${bookingURL}`;
      } else if (url.indexOf("PM=") != -1) {
        bookingURL = `${bookingURL}BM`;
      } else {
        bookingURL = `${bookingURL}?PM=BM`;
      }
    }

    form.setAttribute("method", "post");
    form.setAttribute("action", `${bookingURL}`);
    form.setAttribute("className", "hiddenForm");

    // setting form target to a window named 'formresult'
    form.setAttribute("target", "_blank");

    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("name", "rdfrom");
    hiddenField.setAttribute("value", `${this.props.data.match.params.from}`);
    form.appendChild(hiddenField);

    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("name", "rdto");
    hiddenField.setAttribute("value", `${this.props.data.match.params.to}`);
    form.appendChild(hiddenField);

    let sdateToPost = moment(
      this.props.data.match.params.sdate,
      "YYYY-MM-DD"
    ).format("YYYY;MM;DD;");
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("name", "rddate");
    hiddenField.setAttribute("value", `${sdateToPost}`);
    form.appendChild(hiddenField);

    if (
      this.props.data.match.params.sdate !== this.props.data.match.params.edate
    ) {
      var hiddenField = document.createElement("input");
      hiddenField.setAttribute("name", "rdfrom2");
      hiddenField.setAttribute("value", `${this.props.data.match.params.to}`);
      form.appendChild(hiddenField);

      var hiddenField = document.createElement("input");
      hiddenField.setAttribute("name", "rdto2");
      hiddenField.setAttribute("value", `${this.props.data.match.params.from}`);
      form.appendChild(hiddenField);

      let edateToPost = moment(
        this.props.data.match.params.edate,
        "YYYY-MM-DD"
      ).format("YYYY;MM;DD;");
      var hiddenField = document.createElement("input");
      hiddenField.setAttribute("name", "rddate2");
      hiddenField.setAttribute("value", `${edateToPost}`);
      form.appendChild(hiddenField);
    }

    document.body.appendChild(form);
    form.submit();

    form.parentNode.removeChild(form);
  };

  redirectToAgencies = () => {
    const outgoingTrip = JSON.parse(localStorage.getItem("outgoingTrip"));
    ReactGA.event({
      category: "Agencies",
      action: "agencyBooking",
      label: `${this.props.data.match.params.sdate}#${moment(
        outgoingTrip.departureDateTime
      ).format("hhmm")}#${outgoingTrip.company.id}#${
        outgoingTrip.departureLocation.id
      }#${outgoingTrip.arrivalLocation.id}#${outgoingTrip.vessel.id}#${moment(
        this.props.data.match.params.sdate
      ).format("YYYYMMDD")}#${moment(this.props.data.match.params.edate).format(
        "YYYYMMDD"
      )}#2b735297-625f-412f-8bd0-6a6498d494e0#2104675081`
    });
    this.props.data.history.push(
      `/${this.props.data.match.params.from}/${
        this.props.data.match.params.to
      }/${this.props.data.match.params.sdate}/${
        this.props.data.match.params.edate
      }/agencies`
    );
    this.setState({ redirect: true });
  };

  redirectToItineraries = () => {
    this.props.data.history.push(
      `/${this.props.data.match.params.from}/${
        this.props.data.match.params.to
      }/${this.props.data.match.params.sdate}/${
        this.props.data.match.params.edate
      }/itineraries`
    );
    this.setState({ redirectBack: true });
  };

  componentDidMount() {
    const outgoingTrip = JSON.parse(localStorage.getItem("outgoingTrip"));
    const incomingTrip = JSON.parse(localStorage.getItem("incomingTrip"));

    const arrivalLocation = outgoingTrip.arrivalLocation;
    const departureLocation = outgoingTrip.departureLocation;

    if (outgoingTrip) {
      let outgoingTripBody = `{
                "departureDateTime": "${outgoingTrip.departureDateTime}",
                "departureLocation": {"id": ${
                  outgoingTrip.departureLocation.id
                }, "code":"${outgoingTrip.departureLocation.code}" },
                "arrivalLocation": {"id": ${
                  outgoingTrip.arrivalLocation.id
                }, "code":"${outgoingTrip.arrivalLocation.code}" },
                "company": {"id": ${outgoingTrip.company.id}, "code":"${
        outgoingTrip.company.code
      }" },
                "vessel": {"id": ${outgoingTrip.vessel.id}, "code":"${
        outgoingTrip.vessel.code
      }" }
            }`;
      fetch(
        `${FETCH_URL}/proxy.php?ws=8658e99e2006afd27b0d85aa3a88a3a5/${getLanguage()}`,
        {
          method: "POST",
          body: outgoingTripBody
        }
      )
        .then(response => response.json())
        .then(responseJson => {
          this.setState({
            outgoingShipData: responseJson,
            outgoingAgencyBookingURL: responseJson.company.bookingEngineUrl
          });
        })
        .then(() => this._scrollTo())
        .catch(error => {
          console.error(error);
        });
    }

    if (incomingTrip && this.props.data.match.params.sdate) {
      let incomingTripBody = `{
                "departureDateTime": "${incomingTrip.departureDateTime}",
                "departureLocation": {"id": ${
                  incomingTrip.departureLocation.id
                }, "code":"${incomingTrip.departureLocation.code}" },
                "arrivalLocation": {"id": ${
                  incomingTrip.arrivalLocation.id
                }, "code":"${incomingTrip.arrivalLocation.code}" },
                "company": {"id": ${incomingTrip.company.id}, "code":"${
        incomingTrip.company.code
      }" },
                "vessel": {"id": ${incomingTrip.vessel.id}, "code":"${
        incomingTrip.vessel.code
      }" }
            }`;

      fetch(
        `${FETCH_URL}/proxy.php?ws=8658e99e2006afd27b0d85aa3a88a3a5/${getLanguage()}`,
        {
          method: "POST",
          body: incomingTripBody
        }
      )
        .then(response => response.json())
        .then(responseJson => {
           // console.log(responseJson);
          this.setState({
            incomingShipData: responseJson,
            incomingAgencyBookingURL: responseJson.company.bookingEngineUrl
          });
        })
        .catch(error => {
          console.error(error);
        });
    }

    this.setState({
      incomingTrip: incomingTrip,
      outgoingTrip: outgoingTrip,
      departureLocation: departureLocation,
      arrivalLocation: arrivalLocation,
    });
  }

  _scrollTo = () => {
    this.timeOut = setTimeout(() => scroll.scrollTo(500), 250)
  }

  componentWillUnmount() {
    clearTimeout(this.timeOut);
  }

  render() {
    if (!this.state.outgoingTrip) {
      <Redirect
        to={{
          pathname: `/${this.props.data.data.settings.departurePortCode}/${
            this.props.data.data.settings.arrivalPortCode
          }/${this.props.data.data.settings.startDate}/${
            this.props.data.data.settings.endDate
          }/itineraries`
        }}
      />;
    }

    if (this.state.redirectBack) {
      return (
        <Redirect
          to={{
            pathname: `/${this.props.data.data.settings.departurePortCode}/${
              this.props.data.data.settings.arrivalPortCode
            }/${this.props.data.data.settings.startDate}/${
              this.props.data.data.settings.endDate
            }/itineraries`
          }}
        />
      );
    }

    if (this.state.redirect) {
      return (
        <Redirect
          to={{
            pathname: `/${this.props.data.data.settings.departurePortCode}/${
              this.props.data.data.settings.arrivalPortCode
            }/${this.props.data.data.settings.startDate}/${
              this.props.data.data.settings.endDate
            }/agencies`
          }}
        />
      );
    }

    return (
      <div id="shipsContent">
        <Row style={{ margin: "0px", marginTop: "20px" }}>
          <div className="stepCounter">2</div>
          <div className="stepLabel">
            {translate(getLanguage(), "Route Analysis")}
          </div>
        </Row>

        <Row style={{ margin: "0px", marginTop: "20px" }}>
          <div className="stepLabel" style={{ margin: "0px" }}>
            {translate(getLanguage(), "Departure")}
          </div>
          {this.state.departureLocation &&
            this.state.arrivalLocation && (
              <div>
                <div className="portName">
                  {this.state.outgoingTrip.departureLocation.name}
                </div>
                <div className="portArrow">
                  <svg
                    viewBox="0 0 1000 1000"
                    className="DateRangePickerInput_arrow_svg DateRangePickerInput_arrow_svg_1"
                  >
                    <path d="M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z" />
                  </svg>
                </div>
                <div className="portName">
                  {this.state.outgoingTrip.arrivalLocation.name}
                </div>
              </div>
            )}
          <div className="departureDayLabel">
            {translate(getLanguage(), "Departure Date")}
          </div>
          <div className="departureDayText">
            {this.state.outgoingTrip &&
              moment(
                this.state.outgoingTrip.departureDateTime,
                "YYYY-MM-DD HH:mm:ss"
              ).format("dddd DD MMMM YYYY")}
          </div>
        </Row>

        {this.state.outgoingShipData && (
          <Row
            style={{ margin: "0px", marginTop: "30px", marginBottom: "30px" }}
          >
            {!this.state.incomingShipData && (
              <Button
                style={{ float: "left", position: "relative" }}
                className="searchButton bookingButton"
                primary
                loading={this.props.isloading}
                onClick={() => this.redirectToItineraries()}
              >
                {translate(getLanguage(), "Back")}
              </Button>
            )}
            {this.state.outgoingAgencyBookingURL ? (
              <Button
                style={{
                  float: "right",
                  position: "relative",
                  marginLeft: "10px",
                }}
                className="searchButton bookingButton"
                primary
                loading={this.props.isloading}
                onClick={() =>
                  this.goToBookingURL(this.state.outgoingAgencyBookingURL)
                }
              >
                {translate(getLanguage(), "Online Ferry Booking")}
              </Button>
            ) : (
              ""
            )}
            <Button
              style={{ float: "right", position: "relative"}}
              className="searchButton bookingButton"
              primary
              loading={this.props.isloading}
              onClick={() => this.redirectToAgencies()}
            >
              {translate(getLanguage(), "Booking Agencies")}
            </Button>
          </Row>
        )}

        {this.state.outgoingShipData && (
          <Row style={{ margin: "0px", marginTop: "20px" }}>
            <OSShipCard
              image={this.state.outgoingShipData.vessel.imageUrl}
              title={this.state.outgoingShipData.vessel.name}
              cabins={this.state.outgoingShipData.vessel.hasCabins}
              garage={this.state.outgoingShipData.vessel.hasGarage}
              kind={this.state.outgoingShipData.vessel.kind}
              companyImage={this.state.outgoingShipData.company.imageUrl}
              accommodations={this.state.outgoingShipData.accommodations}
            />
            <div className="OSShipTableContainer">
              <MapWithADirectionsRenderer
                trip={this.state.outgoingShipData.intermediateStops}
                finalStop={this.state.arrivalLocation.name}
                googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyDF9MTsdQEmSiTZxeyxN_0kXFW0OMEIu-I&language=en&libraries=geometry,drawing,places"
                loadingElement={<div style={{ height: `300px` }} />}
                containerElement={<div style={{ height: `300px` }} />}
                mapElement={
                  <div
                    style={{
                      height: "300px",
                      marginBottom: "10px",
                      boxShadow: "0px 0px 7px #888888"
                    }}
                  />
                }
              />

              <OSShipCardTable
                stops={this.state.outgoingShipData.intermediateStops}
                finalStop={this.state.outgoingTrip.arrivalLocation.name}
              />
            </div>
          </Row>
        )}

        

        {this.state.incomingShipData && (
          <div>
            <Row style={{ margin: "0px", marginTop: "20px" }}>
              <div className="stepLabel" style={{ margin: "0px" }}>
                {translate(getLanguage(), "Return")}
              </div>
              {this.state.incomingTrip &&
                (
                  <div>
                    <div className="portName">
                      {this.state.incomingTrip.departureLocation.name}
                    </div>
                    <div className="portArrow">
                      <svg
                        viewBox="0 0 1000 1000"
                        className="DateRangePickerInput_arrow_svg DateRangePickerInput_arrow_svg_1"
                      >
                        <path d="M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z" />
                      </svg>
                    </div>
                    <div className="portName">
                      {this.state.incomingTrip.arrivalLocation.name}
                    </div>
                  </div>
                )}
              <div className="departureDayLabel">
                {translate(getLanguage(), "Departure Date")}
              </div>
              <div className="departureDayText">
                {this.state.incomingTrip &&
                  moment(
                    this.state.incomingTrip.departureDateTime,
                    "YYYY-MM-DD HH:mm:ss"
                  ).format("dddd DD MMMM YYYY")}
              </div>
            </Row>
            <Row style={{ margin: "0px", marginTop: "20px" }}>
              <OSShipCard
                image={this.state.incomingShipData.vessel.imageUrl}
                title={this.state.incomingShipData.vessel.name}
                cabins={this.state.incomingShipData.vessel.hasCabins}
                garage={this.state.incomingShipData.vessel.hasGarage}
                kind={this.state.incomingShipData.vessel.kind}
                companyImage={this.state.incomingShipData.company.imageUrl}
                accommodations={this.state.incomingShipData.accommodations}
                language={getLanguage()}
              />
              <div className="OSShipTableContainer">
                <MapWithADirectionsRenderer
                  trip={this.state.incomingShipData.intermediateStops}
                  finalStop={this.state.incomingTrip.departureLocation.name}
                  googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyDF9MTsdQEmSiTZxeyxN_0kXFW0OMEIu-I&language=en&libraries=geometry,drawing,places"
                  loadingElement={<div style={{ height: `300px` }} />}
                  containerElement={<div style={{ height: `300px` }} />}
                  mapElement={
                    <div
                      style={{
                        height: "300px",
                        marginBottom: "10px",
                        boxShadow: "0px 0px 7px #888888"
                      }}
                    />
                  }
                />
                <OSShipCardTable
                  finalStop={this.state.incomingTrip.arrivalLocation.name}
                  stops={this.state.incomingShipData.intermediateStops}
                  language={getLanguage()}
                />
              </div>
            </Row>
          </div>
        )}

        {this.state.incomingShipData && (
          <Row
            style={{ margin: "0px", marginTop: "30px", marginBottom: "30px" }}
          >
            <Button
              style={{ float: "left", position: "relative" }}
              className="searchButton bookingButton"
              primary
              loading={this.props.isloading}
              onClick={() => this.redirectToItineraries()}
            >
              {translate(getLanguage(), "Back")}
            </Button>
            {this.state.incomingAgencyBookingURL ? (
              <Button
                style={{
                  float: "right",
                  position: "relative",
                  marginLeft: "10px"
                }}
                className="searchButton bookingButton"
                primary
                loading={this.props.isloading}
                onClick={() =>
                  this.goToBookingURL(this.state.incomingAgencyBookingURL)
                }
              >
                {translate(getLanguage(), "Online Ferry Booking")}
              </Button>
            ) : (
              ""
            )}
            <Button
              style={{ float: "right", position: "relative" }}
              className="searchButton bookingButton"
              primary
              loading={this.props.isloading}
              onClick={() => this.redirectToAgencies()}
            >
              {translate(getLanguage(), "Booking Agencies")}
            </Button>
          </Row>
        )}
      </div>
    );
  }
}

export default ShipsContent;



// WEBPACK FOOTER //
// ./src/components/Pages/Ships/ShipsContent.js